import React, { Fragment } from 'react'
import 'moment/locale/ja'
import { getFromNowAsText } from '../../helpers/timeHelper'
import {
  GPS_TRACKER_LOCATION_STALE_WARNING_MESSAGE,
  shouldShowGpsTrackerLocationStaleWarning,
} from '../../helpers/gpsTrackerLocationWarning'
import {
  iconGpsTracker,
  iconBatteryFull,
  iconBatteryThreeQuarter,
  iconBatteryHalf,
  iconBatteryLittle,
  iconBatteryEmpty,
  iconBatteryUnknown,
} from '../../icons'

type Props = {
  tracker: IGpsTracker
  onClickList?: () => void
}

const GpsTrackersListItem = ({
  tracker,
  onClickList,
}: Props) => {
  const shouldShowLocationWarning = shouldShowGpsTrackerLocationStaleWarning(tracker.status)

  const formatTimestamp = (timestamp?: string | null) => {
    if (!timestamp) return '-'
    return getFromNowAsText(timestamp)
  }

  const getBatteryIcon = (percentage: number | undefined) => {
    if (percentage === undefined || percentage === null) return iconBatteryUnknown
    if (percentage >= 75) return iconBatteryFull
    if (percentage > 50) return iconBatteryThreeQuarter
    if (percentage >= 25) return iconBatteryHalf
    if (percentage >= 5) return iconBatteryLittle
    return iconBatteryEmpty
  }

  const formatBatteryPercentage = (percentage: number | undefined) => {
    if (percentage === undefined || percentage === null) return '-'
    return `${percentage}%`
  }

  return (
    <Fragment key={tracker.device_token}>
      <tr
        className="list-row overview-item-list-item"
        key={tracker.device_token}
        onClick={onClickList}
        style={{ cursor: onClickList ? 'pointer' : 'default' }}
      >
        {/* ----- アイテム名 ----- */}
        <td className="item item-name">
          <div className="img-name-item">
            <img className="item-icon" src={iconGpsTracker} alt="gps-tracker" />
            <strong className="item-name-text">
              {tracker.name}
            </strong>
          </div>
        </td>
        {/* ----- 定期通信 ----- */}
        <td className="item item-last-detected-at">
          {formatTimestamp(tracker.status?.heartbeat_received_at)}
        </td>
        {/* ----- 端末の情報取得 ----- */}
        <td className="item item-last-detected-at">
          {formatTimestamp(tracker.status?.tracked_at)}
        </td>
        {/* ----- 最終GPS位置更新時刻 ----- */}
        <td className="item item-last-detected-at">
          <div>
            {formatTimestamp(tracker.status?.gps_location_updated_at)}
          </div>
          {shouldShowLocationWarning && (
            <div className="gps-tracker-location-warning" role="status">
              <span className="gps-tracker-location-warning__icon" aria-hidden="true">!</span>
              <span className="gps-tracker-location-warning__message">
                {GPS_TRACKER_LOCATION_STALE_WARNING_MESSAGE}
              </span>
            </div>
          )}
        </td>
        {/* ----- 所持者 ----- */}
        <td className="item">
          <div className="status">
            <div className="main">
              <div className="sub">
                <span className="rental-owner">
                  {tracker.user ? tracker.user.name : '-'}
                </span>
              </div>
            </div>
          </div>
        </td>
        {/* ----- バッテリー残量 ----- */}
        <td className="item">
          <div className="battery-status">
            <img
              className="battery-icon"
              src={getBatteryIcon(tracker.status?.battery_percentage)}
              alt="battery"
              style={{ width: '20px', height: '20px', marginRight: '8px' }}
            />
            <span>{formatBatteryPercentage(tracker.status?.battery_percentage)}</span>
          </div>
        </td>
      </tr>

      <tr key={`divider-${tracker.device_token}`} className="divider">
        <td colSpan={6}>
          <div className="line" />
        </td>
      </tr>
    </Fragment>
  )
}

export default GpsTrackersListItem
